import { createRef, useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import { httpGet } from '../../utils/httpClient';
import styles from './News.module.scss';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import 'react-multi-carousel/lib/styles.css';
import { CustomLeftArrow, CustomRightArrow } from '../Carousel/arrows/arrows';
import { useWindowWidth } from '@react-hook/window-size';
import { useTranslation } from 'next-i18next';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
    slidesToSlide: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToe: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slideside: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    sieTS: 1,
  },
};
const ButtonGroup = ({ next, previous }) => {
  const width = useWindowWidth();
  return (
    <div className="carousel-button-group">
      <CustomLeftArrow
        left={width < 1024 ? 0 : -40}
        position={'absolute'}
        onClick={() => previous()}
      />
      <CustomRightArrow
        onClick={() => next()}
        right={width < 1024 ? 0 : -40}
        position={'absolute'}
      />
    </div>
  );
};
const getNews = async () => {
  return await (await httpGet(`/api/article?&subtype=News&size=9`)).json();
};

const News = ({ news, showTitle = true, inverse = false }) => {
  const { t } = useTranslation();
  const [articles, setArticles] = useState([]);
  const width = useWindowWidth();
  const [carouselHeight, setCarouselHeight] = useState(0);
  const carousel = createRef();
  useEffect(() => {
    setCarouselHeight(carousel.current?.offsetWidth / 1.78);
  }, [carousel, width]);
  useEffect(() => {
    if (!news) {
      getNews().then((res) => {
        setArticles([...articles, ...res.content]);
      });
    } else {
      setArticles([...news]);
    }
  }, [news]);
  return (
    <div
      className={cn(styles.newsContainer, {
        [styles.inverse]: inverse,
        'bg-brown-background': !inverse,
      })}
    >
      {showTitle && (
        <span className={cn(styles.heading, 'font-fragment')}>
          {t('index.news')}
        </span>
      )}
      <Carousel
        infinite={true}
        responsive={responsive}
        autoPlaySpeed={5000}
        swipeable={true}
        draggable={false}
        arrows={false}
        renderButtonGroupOutside={true}
        slidesToSlide={width >= 1024 ? 3 : 1}
        containerClass={styles.carouselContainer}
        customButtonGroup={<ButtonGroup width={width} />}
      >
        {articles.map((item) => {
          if (item.image?.[0] === '/') {
            item.image = item.image?.replace('/', '');
          }

          if (item.topImage?.image?.[0] === '/') {
            item.topImage.image = item.topImage.image?.replace('/', '');
          }
          return (
            <Link
              href={
                '/' +
                item.type?.toLowerCase() +
                '/' +
                item.subtype?.toLowerCase() +
                '/' +
                item.textId
              }
              key={item.textId}
              aria-label='Reas more'
            >
              <div
                className="cursor-pointer h-full"
                style={{
                  marginRight: '1rem',
                  marginLeft: '1rem',
                  backgroundColor: inverse ? 'white' : 'transparent',
                  boxShadow: '0px 5px 5px 5px rgb(0 0 0 / 2%)',
                }}
              >
                <div
                  ref={carousel}
                  style={{ height: carouselHeight }}
                  className={cn(styles.carouselItem, 'relative')}
                >
                  <Image
                    src={
                      process.env.mediaUrl +
                      (item.topImage?.image || item.image)
                    }
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                {item.heading && (
                  <span
                    className={cn(
                      styles.carouselItemOverline,
                      'font-libre mt-2'
                    )}
                  >
                    {item.heading}
                  </span>
                )}
                <span
                  className={cn(styles.carouselItemTitle, 'font-fragment', {
                    'mt-6': !item.heading,
                  })}
                >
                  {item.title}
                </span>
                <p
                  className={cn(styles.carouselItemContent, 'font-libre')}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                />
                <p className={cn(styles.readMore, 'font-libre')}>Read more</p>
              </div>
            </Link>
          );
        })}
      </Carousel>
    </div>
  );
};

export default News;
